import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Users } from 'lucide-react';
export function MidPageCTA() {
  return <section className="py-20 px-4 bg-gradient-to-br from-dark-bg to-dark-bg-alt border-y border-violet-900/30 relative overflow-hidden" data-id="element-137">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-64 bg-violet-600/10 blur-[100px] rounded-full pointer-events-none" data-id="element-138" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center gap-6" data-id="element-140">
          <div className="inline-flex items-center gap-2 text-yellow-400 bg-yellow-400/10 px-4 py-2 rounded-full mb-2" data-id="element-141">
            <Users className="w-5 h-5" data-id="element-142" />
            <span className="font-bold" data-id="element-143">Comunidad Creciente</span>
          </div>

          <h2 className="text-3xl md:text-5xl font-display font-bold text-white leading-tight" data-id="element-144">
            🔥 Más de 1.500 personas ya transformaron su vida con el Reiki
            MegaPack
          </h2>

          <p className="text-xl md:text-2xl text-violet-200 font-medium mb-8" data-id="element-145">
            ¿Vas a ser la próxima?
          </p>

          <CTAButton text="¡QUIERO UNIRME AHORA!" size="xl" className="shadow-[0_0_40px_rgba(139,92,246,0.4)]" data-id="element-146" />
        </motion.div>
      </div>
    </section>;
}